
import Vue from 'vue'
import snackbarStore from './store/snackbarStore'
import store from './store'
import MyArqanaHeader from './components/MyArqanaHeader.vue'

export default Vue.extend({
  name: 'App',
  data() {
    return {
      store,
      overlay: false,
      snackbar: snackbarStore.state.snackbar,
    }
  },
  components: {
    MyArqanaHeader,
  },
  watch: {
    'store.state.expiredToken': function expiredToken(value) {
      if (value) {
        this.store.state.expiredToken = false
        this.$router.push({
          path: '/login',
          query: { redirect: this.$route.fullPath, expired: 'expired' },
        })
      }
    },
  },
})
